import {Settings, SettingsOptions} from "./typing";
import {defineRouting} from "next-intl/routing";
import {pathnames} from "./paths";

type Options = Pick<Settings, "navigation"> & Pick<Settings, "presets"> & Pick<Settings, "localization"> & Pick<Settings, "tracking">

const SETTINGS_KEY = '__SETTINGS__.__OPTIONS__';
let settings: SettingsOptions = (globalThis as any)[SETTINGS_KEY] ?? undefined;

/*function pickObjKeys<T extends object, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
    return Object.fromEntries(keys.map((key) => [key, obj[key]])) as Pick<T, K>;
}*/

function parseLocales(i18n: Options["localization"]): SettingsOptions["i18n"] {
    return defineRouting({
        locales: i18n.locales,
        defaultLocale: i18n.default,
        
        localePrefix: {
            mode: 'as-needed',
            prefixes: {
                'en': '/en',
                'lv': undefined,
                'cn': '/zh-hant',
                'lt': '/lt'
            }
        },
        
        localeDetection: false,
        pathnames,
    })
}

export function setOptions(params: Options) {
    if (settings) {
        console.warn('Options are already set');
    }
    
    settings = (globalThis as any)[SETTINGS_KEY] = {
        navigation: params.navigation,
        logo: {
            footer: params.presets.footerLogo,
            header: params.presets.headerLogo,
            email: params.presets.emailLogo
        },
        tracking: {
            fbPixelId: process.env['NODE_ENV'] == 'production' && params.tracking?.fbId ? params.tracking.fbId : null,
            gtmTagId: process.env['NODE_ENV'] == 'production' && params.tracking?.gtmId ? params.tracking.gtmId : null,
        },
        i18n: parseLocales(params.localization),
    };
}

export const options = (): SettingsOptions => {
    if (!settings) {
        throw new Error('Options are not set');
    }
    return settings;
}